import { useEffect, useState } from "react";
import './style.css';
import * as C from './styles.js';
import Load from "../../../../../../components/load";

export default function Trailers({ media_type, movie_id }) {
    
    const [trailers, setTrailers] = useState([]);
    const [showTrailer, setShowTrailer] = useState(false);
    const [loading, setLoading] = useState(true);
    const [languageTrailer, setLanguageTrailer] = useState('pt-BR');

    useEffect(() => {
        setLoading(true);
        fetch(`https://api.themoviedb.org/3/${media_type}/${movie_id}/videos?api_key=${process.env.REACT_APP_TMDB_KEY}&language=${languageTrailer}`)
            .then(response => response.json())
            .then(data => {
                setTrailers(data.results || []);
                setTimeout(() => setLoading(false), 500);
            })
            .catch(() => setLoading(false));
    }, [movie_id, languageTrailer]);

    return (
        <>
            <C.SelectContainer>
                <label htmlFor="languageSelect">Idioma:</label>
                <select 
                    id="languageSelect" 
                    value={languageTrailer} 
                    onChange={(e) => setLanguageTrailer(e.target.value)}
                >
                    <option value="pt-BR">Português</option>
                    <option value="en-US">Inglês</option>
                    <option value="es-ES">Espanhol</option>
                </select>
            </C.SelectContainer>
            {loading ? (
                <Load align_center={true} />
            ) : (
                <div className="content-trailers">
                    <div className="div-trailers-movie">
                        {trailers.length > 0 && trailers.map((trailer, key) => (
                            <button key={key} onClick={() => setShowTrailer(trailer.key)} className="trailer-movie" title={trailer.name}>
                                {trailer.official && (
                                    <header>
                                        {trailer.site === "YouTube" && <span><i className="fa-brands fa-youtube"></i></span>}
                                        <span>Oficial</span>
                                    </header>
                                )}
                                <div className="div-trailer">
                                    <img src={`https://img.youtube.com/vi/${trailer.key}/sddefault.jpg`} alt={trailer.name} />
                                    <span><i className="fa-solid fa-play"></i></span>
                                </div>
                                <span className="span-titulo-trailer">{trailer.name}</span>
                            </button>
                        ))}

                        {showTrailer && (
                            <div className="modal-trailer">
                                <button onClick={() => setShowTrailer('')}><i className="fa-solid fa-arrow-left"></i></button>
                                <iframe 
                                    src={`https://www.youtube.com/embed/${showTrailer}`} 
                                    allowFullScreen 
                                    frameBorder="0"
                                    allow="fullscreen"
                                ></iframe>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {(!loading && trailers.length == 0) &&
                <div className="div-no-trailers">
                    <span className="no-trailers">Não há trailers disponíveis!</span>
                </div>
            }
        </>
    );
}
